import { PATH_DASHBOARD } from "../../routes/paths";
import SvgIconStyle from "../../components/SvgIconStyle";

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/${name}.svg`}
    sx={{ width: "100%", height: "100%" }}
  />
);

const ICONS = {
  blog: getIcon("ic_blog"),
  cart: getIcon("ic_cart"),
  chat: getIcon("ic_chat"),
  mail: getIcon("ic_mail"),
  product: getIcon("ic_products"),
  kanban: getIcon("ic_kanban"),
  banking: getIcon("ic_banking"),
  calendar: getIcon("ic_calendar"),
  analytics: getIcon("ic_analytics"),
  dashboard: getIcon("ic_dashboard"),
  user: getIcon("ic_user"),
  invoice: getIcon("ic_invoice"),
  category: getIcon("ic_category"),
  report: getIcon("ic_report"),
  setting: getIcon("ic_settings"),
  store: getIcon("ic_stores2"),
  task: getIcon("ic_task"),
  salesreport: getIcon("ic_salesreport"),
  cost: getIcon("ic_master_cost"),
  manufacture: getIcon("ic_manufacture"),
  inventory: getIcon("ic_inventory"),
  designmaster: getIcon("ic_designmaster"),
  leaderboard: getIcon("ic_leaderboard"),
  master: getIcon("ic_master"),
  leader: getIcon("ic_leader"),
  datareport: getIcon("ic_data_report"),
  workshop: getIcon("ic_workshop"),
  orderstock: getIcon("ic_stock_order"),
  costreport: getIcon("ic_cost_report"),
};

const getSidebarConfig = (notificationCount = {}) => {
  const sidebarConfig = [];

  sidebarConfig.push(
    // MANAGEMENT
    {
      subheader: "Management",
      items: [
        // DASHBOARD
        {
          title: "Dashboard",
          path: PATH_DASHBOARD.general.app,
          roles: [1, 2, 3, 4, 5],
          icon: ICONS.dashboard,
        },

        // INVOICE
        {
          title: "Invoices",
          path: PATH_DASHBOARD.invoice.root,
          roles: [1, 2, 3, 4, 5],
          icon: ICONS.invoice,
        },
        // TASK
        {
          title: "Tasks",
          path: PATH_DASHBOARD.task.root,
          roles: [1, 2, 3, 5],
          icon: ICONS.task,
          children: [
            { title: "Invoice", path: PATH_DASHBOARD.task.invoiceTask },
            {
              title: "Balance Reminder",
              path: PATH_DASHBOARD.task.balanceReminder,
            },
            {
              title: "Workshop",
              path: PATH_DASHBOARD.task.workshopTask,
              roles: [1],
            },
          ],
        },
        // MANUFACTURE
        {
          title: "Manufacture",
          path: PATH_DASHBOARD.manufacture.root,
          roles: [1, 4, 5],
          icon: ICONS.manufacture,
          children: [
            { title: "Order", path: PATH_DASHBOARD.manufacture.list },
            { title: "Remake", path: PATH_DASHBOARD.manufacture.remakelist },
            { title: "Resize", path: PATH_DASHBOARD.manufacture.resizelist },
            { title: "Repair", path: PATH_DASHBOARD.manufacture.repairlist },
            {
              title: "Master CAD List",
              path: PATH_DASHBOARD.manufacture.mastercardlist,
            },
            {
              title: `Notification (${notificationCount.length})`,
              path: PATH_DASHBOARD.manufacture.notification,
            },
          ],
        },
        // INVENTORY
        {
          title: "Inventory",
          path: PATH_DASHBOARD.inventory.root,
          roles: [1, 2, 4, 5],
          icon: ICONS.inventory,
          children: [
            {
              title: "Lab Grown Inventory",
              path: PATH_DASHBOARD.inventory.labgrown.root,
              children: [
                {
                  title: "Diamond",
                  path: PATH_DASHBOARD.inventory.labgrown.diamond,
                },
                {
                  title: "Gemstone",
                  path: PATH_DASHBOARD.inventory.labgrown.gemstone,
                },
                {
                  title: "Mount",
                  path: PATH_DASHBOARD.inventory.labgrown.mount,
                },
                {
                  title: "Finish Ring",
                  path: PATH_DASHBOARD.inventory.labgrown.finishring,
                },
                {
                  title: "Earrings",
                  path: PATH_DASHBOARD.inventory.labgrown.earrings,
                },
                {
                  title: "Pendants",
                  path: PATH_DASHBOARD.inventory.labgrown.pendants,
                },
                {
                  title: "Bracelet",
                  path: PATH_DASHBOARD.inventory.labgrown.bracelet,
                },
              ],
            },
            {
              title: "Natural Inventory",
              path: PATH_DASHBOARD.inventory.natural.root,
              children: [
                {
                  title: "Diamond",
                  path: PATH_DASHBOARD.inventory.natural.diamond,
                },
                {
                  title: "Gemstone",
                  path: PATH_DASHBOARD.inventory.natural.gemstone,
                },
                {
                  title: "Mount",
                  path: PATH_DASHBOARD.inventory.natural.mount,
                },
                {
                  title: "Finish Ring",
                  path: PATH_DASHBOARD.inventory.natural.finishring,
                },
                {
                  title: "Earrings",
                  path: PATH_DASHBOARD.inventory.natural.earrings,
                },
                {
                  title: "Pendants",
                  path: PATH_DASHBOARD.inventory.natural.pendants,
                },
                {
                  title: "Bracelet",
                  path: PATH_DASHBOARD.inventory.natural.bracelet,
                },
              ],
            },
          ],
        },

        // STOCK ORDERS
        {
          title: "Stock Orders",
          path: PATH_DASHBOARD.stock.root,
          roles: [1, 2, 3, 4, 5],
          icon: ICONS.orderstock,
        },

        // LEADER
        {
          title: "Lead",
          path: PATH_DASHBOARD.lead.root,
          roles: [1, 2, 3, 4, 5],

          icon: ICONS.leader,
          children: [
            { title: "Add Lead", path: PATH_DASHBOARD.lead.newLeader },
            { title: "All Lead", path: PATH_DASHBOARD.lead.allLead },
            { title: "Calendar", path: PATH_DASHBOARD.lead.leadcalender },
          ],
        },
        // PRODUCT
        // {
        //   title: 'Products',
        //   path: PATH_DASHBOARD.product.root,
        //   icon: ICONS.product
        // },
        // COST
        {
          title: "Costs",
          path: PATH_DASHBOARD.cost.root,
          roles: [1, 5],
          icon: ICONS.cost,
          children: [
            { title: "Post-Production", path: PATH_DASHBOARD.cost.postProd },
            { title: "Expenses", path: PATH_DASHBOARD.cost.expense },
          ],
        },

        // MASTER
        {
          title: "Master",
          path: PATH_DASHBOARD.master.root,
          roles: [1],
          icon: ICONS.master,
          children: [
            { title: "Users", path: PATH_DASHBOARD.master.user },
            { title: "Stores", path: PATH_DASHBOARD.master.store },
            { title: "Design", path: PATH_DASHBOARD.master.design },
            { title: "Workshop", path: PATH_DASHBOARD.master.workshop },
          ],
        },

        // REPORTS
        {
          title: "Reports",
          path: PATH_DASHBOARD.report.root,
          roles: [1, 2],
          icon: ICONS.report,
          children: [
            {
              title: "Invoice",
              path: PATH_DASHBOARD.report.invoice.root,
              roles: [1, 2],

              children: [
                {
                  title: "Daily Reports",
                  path: PATH_DASHBOARD.report.invoice.daily,
                },
                {
                  title: "Monthly Reports",
                  path: PATH_DASHBOARD.report.invoice.monthly,
                },
                {
                  title: "Annual Reports",
                  path: PATH_DASHBOARD.report.invoice.annual,
                },
              ],
            },
            {
              title: "Payment",
              path: PATH_DASHBOARD.report.paymentReport.root,

              roles: [1, 2],
              children: [
                {
                  title: "Daily Reports",
                  path: PATH_DASHBOARD.report.paymentReport.daily,
                },
                {
                  title: "Monthly Reports",
                  path: PATH_DASHBOARD.report.paymentReport.monthly,
                },
                {
                  title: "Annual Reports",
                  path: PATH_DASHBOARD.report.paymentReport.annual,
                },
              ],
            },
            {
              title: "Leaderboard",
              path: PATH_DASHBOARD.report.leaderboard.root,
              roles: [1],
              children: [
                {
                  title: "Daily Reports",
                  path: PATH_DASHBOARD.report.leaderboard.daily,
                },
                {
                  title: "Monthly Reports",
                  path: PATH_DASHBOARD.report.leaderboard.monthly,
                },
                {
                  title: "Annual Reports",
                  path: PATH_DASHBOARD.report.leaderboard.annual,
                },
                {
                  title: "Calendar",
                  path: PATH_DASHBOARD.report.leaderboard.calendar,
                },
              ],
            },
            {
              title: "Costs",
              path: PATH_DASHBOARD.report.costReport.root,
              roles: [1],
              children: [
                {
                  title: "Monthly Reports",
                  path: PATH_DASHBOARD.report.costReport.monthly,
                },
                {
                  title: "Annual Reports",
                  path: PATH_DASHBOARD.report.costReport.annual,
                },
              ],
            },
            {
              title: "Data",
              path: PATH_DASHBOARD.report.dataReport.root,
              roles: [1],

              children: [
                {
                  title: "Daily Reports",
                  path: PATH_DASHBOARD.report.dataReport.daily,
                },
                {
                  title: "Monthly Reports",
                  path: PATH_DASHBOARD.report.dataReport.monthly,
                },
                {
                  title: "Annual Reports",
                  path: PATH_DASHBOARD.report.dataReport.annual,
                },
                {
                  title: "Engagement Ring Reports",
                  path: PATH_DASHBOARD.report.dataReport.engagementRing,
                },
              ],
            },
          ],
        },
      ],
    }
  );

  return sidebarConfig;
};

export default getSidebarConfig;
